/**
 * Theme Presets
 *
 * Named color presets that combine primary, secondary, and gray scales.
 * Each preset is designed for visual harmony.
 */
export type ThemePreset = 'indigo' | 'ocean' | 'forest' | 'sunset' | 'grape' | 'rose';

export type ThemeMode = 'light' | 'dark' | 'system';
export type CardSkin = 'bordered' | 'shadow' | 'none';

/**
 * Theme configuration stored in localStorage
 */
export interface ThemeConfig {
  themeMode: ThemeMode;
  cardSkin: CardSkin;
  preset: ThemePreset;
}

/**
 * Preset metadata for UI display
 */
export interface PresetInfo {
  name: ThemePreset;
  label: string;
  description: string;
}

export const THEME_PRESETS: PresetInfo[] = [
  { name: 'indigo', label: 'Indigo', description: 'Professional, default' },
  { name: 'ocean', label: 'Ocean', description: 'Fresh, tech' },
  { name: 'forest', label: 'Forest', description: 'Natural, calm' },
  { name: 'sunset', label: 'Sunset', description: 'Warm, energetic' },
  { name: 'grape', label: 'Grape', description: 'Creative, playful' },
  { name: 'rose', label: 'Rose', description: 'Soft, modern' },
];

// Legacy types - kept for backwards compatibility during migration
// These will be removed in a future cleanup
/** @deprecated Use ThemePreset instead */
export type DarkColor = 'cinder' | 'navy' | 'mirage' | 'black' | 'mint';
/** @deprecated Use ThemePreset instead */
export type LightColor = 'slate' | 'gray' | 'neutral';
/** @deprecated Use ThemePreset instead */
export type PrimaryColor = 'indigo' | 'blue' | 'green' | 'amber' | 'purple' | 'rose';

/** @deprecated Use ThemeConfig instead */
export interface DarkColorScheme {
  name: DarkColor;
  [key: string]: string;
}

/** @deprecated Use ThemeConfig instead */
export interface LightColorScheme {
  name: LightColor;
  [key: string]: string;
}

/** @deprecated Use ThemeConfig instead */
export interface PrimaryColorScheme {
  name: PrimaryColor;
  [key: string]: string;
}
